import $ from 'jquery';

export default function enhanceContextualNav() {
    var currentHref = window.location.pathname,
        $contextualNav = $('.contextual-nav');

    $contextualNav.find('a[href="' + currentHref + '"]')
        .parentsUntil($contextualNav, 'li')
        .addClass('selected');
}
